
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { formatTime } from '@/utils/index';
import Tinymce from '../Tinymce/index.vue';
import { getNoticeList, getNoticeDetail, delNotice, addNotice } from '@/api/notice';
import TemplateTags from '@/views/template/TemplateTags.vue';

@Component({
  name: 'AnnounceList',
  components: {
    Tinymce,
    TemplateTags
  }
})
export default class extends Vue {
  // 1内部公告 2客户公告
  @Prop({
    type: String,
    default: '1'
  })
  listType!: String;

  private formSearch: any = {
    notice_title: ''
  }

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private tableData: any = []

  private listLoading:boolean = false
  private detailVisible:boolean = false
  private detailInfo:any = {}

  private rules = {
    title: [
      {
        required: true,
        message: '请输入公告标题',
        trigger: 'blur'
      }
    ],
    content: [
      {
        required: true,
        message: '请输入公告内容',
        trigger: 'blur'
      }
    ]
  };

  created() {
    this.getNoticeList();
  }

  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getNoticeList();
  }
  private handleClear() {
    this.pagination.currentPage = 1;
    this.formSearch = {
      notice_title: ''
    };
    this.getNoticeList();
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getNoticeList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getNoticeList();
  }

  private getNoticeList() {
  // 1内部公告 2客户公告
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      notice_type: this.listType
    };
    if (this.formSearch.notice_title) {
      params.notice_title = this.formSearch.notice_title;
    }
    getNoticeList(params)
      .then((res) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.currentPage = 1;
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  private handleDetail(val: any) {
    const params:any = {
      id: val.id,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
    };
    getNoticeDetail(params)
      .then((res) => {
        if (res.data) {
          this.detailInfo = res.data;
          this.detailVisible = true;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  private handleDelete(val: any) {
    this.$confirm('是否删除?', '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params:any = {
          id: val.id,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0'
        };
        delNotice(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getNoticeList();
          })
          .catch((err) => {
            let msg = err.msg;
          });
      })
      .catch(() => {});
  }

  private announceVisible = false
  private formAnnounce: any = {
    title: '',
    content: ''
  }
  private announceHandle() {
    this.announceVisible = true;
  }

  private closeAdd() {
    this.announceVisible = false;
    this.formAnnounce = {
      title: '',
      content: ''
    };
  }

  private confirmHandle() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        const params:any = {
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          company_name: UserModule.getCompanyName,
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_logo_path: UserModule.getCompany.logo_path,
          notice_title: this.formAnnounce.title,
          notice_content: this.formAnnounce.content,
          notice_type: this.listType
        };
        addNotice(params)
          .then((res) => {
            this.showSuccessMsg('添加成功');
            this.announceVisible = false;
            this.formAnnounce = {
              title: '',
              content: ''
            };
            this.getNoticeList();
          })
          .catch((err) => {
            let msg = err.msg;
          });
      } else {
        return false;
      }
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
